import React, { useState, useEffect } from "react";
import {
  AppProvider,
  LegacyCard,
  TextField,
  InlineGrid,
  Spinner,
  Button,
  FormLayout,
  Form,
} from "@shopify/polaris";
import en from "@shopify/polaris/locales/en.json";
import { jwtDecode } from "jwt-decode";

export default function ProfileUpdate() {
  const baseUrl = process.env.REACT_APP_API_URL;

  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);
  const [initialLoad, setInitialLoad] = useState(true);
  const [messStatus, setMessStatus] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    const decoded = jwtDecode(token); 
    const userId = decoded.id;

    fetch(`${baseUrl}/api/auth/users/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data && data.name && data.email) {
          setForm({
            name: data.name,
            email: data.email,
            password: "",
          });
        } else {
          setMessStatus("Failed to load user data.");
        }
      })
      .catch(() => setMessStatus("Error fetching user."))
      .finally(() => setInitialLoad(false));
  }, [baseUrl]);

  const handleChange = (field) => (value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = () => {
    const token = localStorage.getItem("token");
    if (!token) return;

    const decoded = jwtDecode(token);
    const userId = decoded.id;
    const adminrole = decoded.role;

    const updatePayload = {
      name: form.name,
      email: form.email,
      adminrole,
    };

    if (form.password.trim()) {
      updatePayload.password = form.password;
    }

    setLoading(true);

    fetch(`${baseUrl}/api/auth/users/${userId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(updatePayload),
    })
      .then(async (res) => {
        const data = await res.json();
        if (!res.ok) throw new Error(data.message || "Update failed");
        setMessStatus("Profile updated successfully.");
      })
      .catch((err) => setMessStatus(err.message))
      .finally(() => setLoading(false));
  };

  return (
    <AppProvider i18n={en}>
      <div className="button_option">
        <h2>Edit Profile</h2>
      </div>

      {initialLoad ? (
        <Spinner accessibilityLabel="Loading profile" size="small" />
      ) : (
        <Form onSubmit={handleSubmit}>
          <LegacyCard sectioned>
            <FormLayout>
              <InlineGrid columns={{ xs: 1, sm: 1, md: 1, lg: 3 }} gap="400">
                <TextField
                  label="Full Name"
                  value={form.name}
                  onChange={handleChange("name")}
                  autoComplete="name"
                />
                <TextField
                  label="Email"
                  value={form.email}
                  onChange={handleChange("email")}
                  type="email"
                  autoComplete="email"
                />
                <TextField
                  label="Password"
                  value={form.password}
                  onChange={handleChange("password")}
                  type="password"
                  autoComplete="new-password"
                  placeholder="Leave blank to keep current"
                />
              </InlineGrid>
            </FormLayout>
          </LegacyCard>

          {messStatus && <p className="sucess_mess">{messStatus}</p>}

          <div className="customerAddBtn" style={{ marginTop: "1rem" }}>
            {!loading ? (
              <Button submit variant="primary">
                Save Profile
              </Button>
            ) : (
              <Spinner accessibilityLabel="Updating profile" size="small" />
            )}
          </div>
        </Form>
      )}
    </AppProvider>
  );
}
